<template>
  <div class="sign">
    <h1>PEISO</h1>
    <div class="input-item">
      <el-input type="text" @keyup.enter.native="sign" v-model="mobile" placeholder="Account" @input="validate('account')" />
      <div class="line" :class="{'warn': mobileWarn}"></div>
    </div>
    <div class="input-item" style="margin-bottom:65px">
      <el-input type="password" @keyup.enter.native="sign" v-model="password" placeholder="Password" @input="validate('psd')" />
      <div class="line" :class="{'warn': passwordWarn}"></div>
    </div>
    <button @click="sign">Login</button>
  </div>
</template>

<script>
import api from '../../api/login'

export default {
  name: 'login',
  data () {
    return {
      mobile: '',
      mobileWarn: false,
      password: '',
      passwordWarn: false
    }
  },
  methods: {
    sign () {
      var that = this
      if (that.mobile.replace(/\s+/g,'') == '') {
        that.mobileWarn = true
      }
      if (that.password.replace(/\s+/g,'') == '') {
        that.passwordWarn = true
      }
      if (that.mobile.replace(/\s+/g,'') == '' || that.password.replace(/\s+/g,'') == '') {
        return
      }
      api.signIn({
        params: {
          password: that.password,
          userName: that.mobile,
        },
        callback: that.callback
      })
    },
    validate (txt) {
      var that = this
      if (txt == 'account') {
        if (that.mobile.length > 0) {
          that.mobileWarn = false
        }
      } else {
        if (that.password.length > 0) {
          that.passwordWarn = false
        }
      }
    },
    callback (res) {
      var that = this
      if (res.data.code == 0) {
        sessionStorage.setItem('token', res.data.data.token)
        that.$router.push('/account')
      } else {
        that.$box.alert('', res.data.message, 'error')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sign{
  width: 410px;
  height: 420px;
  background: #2B3444;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -210px 0 0 -205px;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 50px 50px 0 50px;
  h1{
    font-size: 30px;
    text-align:center;
    letter-spacing: 10px;
    margin-bottom: 50px;
    color: #fff;
    font-family: 'PingFangSC-Semibold';
    span{
      transition: all .5s;
      top: -30px;
      position: relative;
      opacity: 0;
    }
  }
  .show{
    .span0{
      top: 0;
      transition: all .7s;
      opacity: 1;
    }
    .span1{
      top: 0;
      transition: all 0.55s;
      opacity: 1;
    }
    .span2{
      top: 0;
      transition: all 0.4s;
      opacity: 1;
    }
    .span3{
      top: 0;
      transition: all 0.25s;
      opacity: 1;
    }
    .span4{
      top: 0;
      transition: all 0.1s;
      opacity: 1;
    }
  }
  .input-item{
    margin-bottom: 30px;
    position: relative;
    .line{
      width: 0;
      position: absolute;
      left: 0;
      bottom: 0;
      height: 1px;
      border-bottom: 1px solid #EA3796;
      overflow: hidden;
      transition: all .3s;
    }
    .warn{
      width: 100%;
    }
  }
  p{
    font-size: 12px;
    text-align:right;
    color: #fff;
    margin-bottom: 40px;
    span{
      cursor: pointer;
    }
  }
  button{
    display: block;
    outline: none;
    background: none;
    cursor: pointer;
    width: 310px;
    height: 50px;
    border: 2px solid #EA3796;
    color: #EA3796;
    margin: 0 auto;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue